import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { DotsSixVertical } from '@phosphor-icons/react'

const icons = {
   drag: DotsSixVertical
}

const PageElementRow = ({ name, icon }) => {
   const Icon = icons[icon || 'text']

   return (
      <div className="flex items-center gap-4 h-10 text-white/80 border-b border-solid border-neutral-100/10 text-sm last:border-b-0 scale-90">
         <Icon size={16} weight="bold" className="opacity-70" />
         <div>{name}</div>
      </div>
   )
}

PageElementRow.propTypes = {
   name: PropTypes.string.isRequired,
   icon: PropTypes.string.isRequired
}

const BlogFeature = ({ active }) => {
   const [visible, setVisible] = useState(false)

   useEffect(() => {
      if (active) {
         setTimeout(() => {
            setVisible(true)
         }, 200)
      } else {
         setVisible(false)
      }
   }, [active])

   return (
      <div className="w-full h-full">
         <div
            className={classNames(
               'absolute top-[18%] left-[15%] w-[100%] bg-white p-2 rounded-3xl overflow-hidden shadow-[0px_10px_30px_rgba(0,0,0,0.3)] transition-all duration-700',
               visible ? 'translate-x-0 opacitx-100' : 'translate-x-10 opacity-0'
            )}>
            <img
               className="w-full"
               src="/assets/custom/communities/images/features/blog/1.jpg"
               alt="Blog"
            />
         </div>

         <div
            className={classNames(
               'absolute top-[0%] sm:top-[10%] -right-[15%] w-[60%] rounded-3xl overflow-hidden shadow-[0px_10px_30px_rgba(0,0,0,0.3)] border border-solid border-neutral-100/10 bg-neutral-950 transition-all duration-700 delay-200 scale-75 sm:scale-100',
               visible ? 'translate-x-0 opacity-100' : 'translate-x-10 opacity-0'
            )}>
            <div className="w-full flex flex-col px-1 pb-1">
               <div className="flex items-center h-12 px-4 text-xs text-white font-semibold">Pages</div>
               <PageElementRow name="About Us" icon="drag" />
               <PageElementRow name="Services" icon="drag" />
               <PageElementRow name="Blog" icon="drag" />
               <PageElementRow name="Resources" icon="drag" />
               <PageElementRow name="Contact Us" icon="drag" />
            </div>
         </div>
      </div>
   )
}

BlogFeature.propTypes = {
   active: PropTypes.bool.isRequired
}

export default BlogFeature
